<template>
	<div>
		<!-- 精彩直播-->
		<div class="expert">
			<Breadcrumb></Breadcrumb>
			<div class="pad-16 col-22 boxshow">
				<div class="flex-1" style="margin-bottom: 24px;" v-for="(item,index) in expertList" :key="index"
					@click="xiaoe(item)">
					<div class="tttile">
						<img :src="item.coverImg" alt="" class="hed-img">
						<p class="first"
							:class="item.livingStatus=='1000'?'first-1':item.livingStatus=='2000'?'first-2':'first-3'">
							{{item.livingStatus=='1000'?'待开始':item.livingStatus=='2000'?'进行中':'已结束'}}
						</p>
					</div>
					<div class="flex-1 jus-bet" style="width: 75%;">

						<div style="padding-right: 48px;">
							<div class="flex-1 just-bet mb-8" style="    margin-bottom: 58px;">
								<p class="name-1">{{item.name}}</p>
							</div>
							<!--  <div class="flex-1 just-bet mb-8" style="align-items: baseline;">
                            <p class="name-2">培训简介:</p>
                            <p class="name-3">
                                {{item.gooat}}
                            </p>
                        </div> -->
							<div class="flex-1 just-bet" style="margin-bottom: 22px;">
								<p class="name-2">活动时间:</p>
								<p class="name-3">
									{{utils.getNowTime(item.startTime)}}-{{utils.getNowTime(item.endTime)}}
								</p>
							</div>
						</div>
						<div class="mt-23">
							<p class="mon-1">¥&nbsp;{{item.price}}</p>
							<div class="online">
								{{item.livingStatus=='3000'?'观看回放':'观看直播'}}
							</div>
						</div>
					</div>
				</div>
				<el-pagination v-show="pageInline.tableTotal>0" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :page-sizes="pageGroup.sizes" :page-size="pageGroup.size"
					layout="total, sizes, prev, pager, next, jumper" :total="pageInline.tableTotal">
				</el-pagination>
			</div>
		</div>
		<footers v-if="footersType == 0"></footers>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import footers from '@/views/footers.vue';
	import {
		getList,
	} from '@/api/broadcast/api.js';
	export default {
		components: {
			Breadcrumb,
			footers
		},
		data() {
			return {
				expertList: [],
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},
				footersType: 0,
			}
		},
		created() {

		},
		mounted() {
			this.footersType = this.$route.query.footersType || 0;
			this.getInit();
		},
		methods: {
			getInit() {
				let params = {
					pageNo: 1,
					pageSize: this.pageGroup.size,
				}
				getList(params).then(res => {
						this.expertList = res.data.list;
						this.pageInline.tableTotal = res.data.total;
					})
					.catch(error => {

					});
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			xiaoe(item) {
				window.open(item.linkUrl)
			}
		}
	}
</script>

<style scoped>
	.expert {
		padding: 0 19%;
		/* margin-bottom: 100px; */
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
		/* justify-content: space-between; */
	}


	.jus-bet {
		justify-content: space-between;
	}

	.align-1 {
		align-items: center;
	}

	.col-22 {
		color: #222222;

	}

	.tttile {
		position: relative;
	}

	.hed-img {
		width: 288rpx;
		height: 173px;
		margin-right: 16px;
		border-radius: 8px;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.name-1 {
		font-size: 20px;
		padding-right: 9px;
		padding-top: 35px;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		font-size: 14px;
		font-weight: normal;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.footers {
		margin-top: 25px !important;
	}

	.online {
		font-size: 14px;
		color: #3377FF;
		padding: 8px 16px;
		background: #F0F5FF;
		white-space: nowrap;
		border-radius: 35px 35px 35px 35px;
	}

	.mon-1 {
		font-size: 20px;
		color: #FF5533;
		padding-bottom: 50px;
	}

	.mt-23 {
		margin-top: 23px;
	}

	.first {
		font-size: 14px;
		font-weight: normal;
		/* line-height: 21px; */
		position: absolute;
		left: 0;
		top: 0;
		border-radius: 4px 16px 4px 16px;
		padding: 4px 16px;
	}

	.first-1 {
		color: #FBB54C;
		background: #FFF6F0;
	}

	.first-2 {
		color: #3ECC64;
		background: #EBFAEF;
	}

	.first-3 {
		color: #FF534D;
		background: #FFF0F0;
	}

	.boxshow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
		margin-top: 16px;
	}
</style>